import useCommonSearchQuery from "@repo/shopifyV2/queries/useSearchQuery";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useSearch(initialVariables?: Record<string, unknown> | null) {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonSearchQuery({
    initialSearchVariables: initialVariables ?? null,
    lang,
    openToast,
  });
}
